import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style.css';

const IntroCardFooter = () => {
  return (
    <>
      <hr/>
      <div className='intro-card-footer'>
        <div className='grid-left'>5 Mins</div>
        <div className='grid-right'>1 Activity</div>
      </div>
    </>
  );
};

export default IntroCardFooter;
